import { IconBotOutline } from '@icons/IconBotOutline'
import { motion } from 'motion/react'

// Typing indicator component
export const TypingIndicator: React.FC = () => (
  <motion.div
    className="mb-4 flex gap-3"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3 }}
  >
    <div className="bg-offwhite flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-muted-foreground/80">
      <IconBotOutline size={16} />
    </div>
    <div className="bg-offwhite flex items-center rounded-2xl rounded-bl-sm p-5">
      <div className="flex gap-1">
        <div
          className="h-1 w-1 animate-bounce-alt rounded-full bg-muted-foreground/80"
          style={{ animationDelay: '0ms' }}
        ></div>
        <div
          className="h-1 w-1 animate-bounce-alt rounded-full bg-muted-foreground/80"
          style={{ animationDelay: '300ms' }}
        ></div>
        <div
          className="h-1 w-1 animate-bounce-alt rounded-full bg-muted-foreground/80"
          style={{ animationDelay: '600ms' }}
        ></div>
      </div>
    </div>
  </motion.div>
)
